import { EntidadBancariaDtoProps } from "api/DTOs/EntidadBancariaDto"
import { getEntidadBancariaByIban } from "api/EntidadBancaria.services"
import { useState } from "react"

interface UseBankAccountFormProps {
  bankList: EntidadBancariaDtoProps[]
  setFieldValue: (field: string, value: string) => void
  setKeyWord: React.Dispatch<React.SetStateAction<string>>
}

export default function useBankAccountForm({
  bankList,
  setFieldValue,
  setKeyWord,
}: UseBankAccountFormProps) {
  const [selectedBank, setSelectedBank] = useState<
    EntidadBancariaDtoProps | undefined
  >()
  const [selectedBic, setSelectedBic] = useState<string | undefined>()
  const [selectedIban, setSelectedIban] = useState<EntidadBancariaDtoProps>()
  const [isBicEditable, setIsBicEditable] = useState(false)

  const handleSelectBank = (bankId: string) => {
    const bank = bankList?.find((bank) => bank.id === bankId)
    setSelectedBank(bank)
    bank?.id && setFieldValue("entidadBancariaId", bank?.id)
    if (bank?.bic) {
      setSelectedBic(bank.bic)
      setFieldValue("bic", bank.bic)
      setSelectedBic(bank.bic)
    }
    setIsBicEditable(Boolean(!bank?.bic))
  }

  const handleGetIban = async (
    value: string,
    setFieldValue: (field: string, value: string) => void
  ) => {
    try {
      const selectedIban = await getEntidadBancariaByIban(value)
      setSelectedIban(selectedIban)
      selectedIban?.nombre && setKeyWord(selectedIban?.nombre)
      setSelectedBank(selectedIban)
      selectedIban?.id && setFieldValue("entidadBancariaId", selectedIban.id)
      if (selectedIban?.bic) {
        setFieldValue("bic", selectedIban?.bic)
        setSelectedBic(selectedIban?.bic)
      } else {
        setIsBicEditable(Boolean(!selectedIban?.bic))
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error al obtener entidad bancaria por IBAN:", error)
      setSelectedBank(undefined)
      setIsBicEditable(false)
    }
  }

  return {
    bankList,
    selectedIban,
    selectedBank,
    selectedBic,
    isBicEditable,
    setSelectedBank,
    setSelectedIban,
    setSelectedBic,
    handleSelectBank,
    setIsBicEditable,
    handleGetIban,
  }
}
